// Ce s-a adus o dată nu se mai aşteaptă a doua oară.
//
// Trecerea între «Лента», «Мой профиль» şi «Участники» reconstruia secţiunea de la zero
// şi cerea din nou aceleaşi date. Chiar şi cu serverul rapid, între apăsare şi primul
// text treceau câteva sute de milisecunde de pagină goală — de fiecare dată, inclusiv
// când te întorceai la ceva ce tocmai închiseseşi.
//
// Aici ţinem ultimul răspuns al fiecărei cereri. Secţiunea desenează pe loc ce are, apoi
// întreabă serverul şi redesenează **doar dacă răspunsul chiar diferă**. Aşa nu vezi
// niciodată o pagină goală, iar când nu s-a schimbat nimic nu vezi nici o clipire.
//
// E o memorie de sesiune, nu un cache adevărat: trăieşte cât ţine fila deschisă şi nu
// pretinde că ştie când se învecheşte ceva. De aceea are o vârstă scurtă şi de aceea
// întrebarea către server pleacă oricum, de fiecare dată.

const memorie = new Map();

/** Cât timp mai are rost să arătăm un răspuns vechi înainte să sosească cel nou. */
const VIATA = 120_000;

export function pune(cheie, valoare) {
  memorie.set(cheie, { valoare, cand: Date.now() });
}

/** Ultimul răspuns pentru cheia dată, dacă nu e prea vechi. */
export function ia(cheie, viata = VIATA) {
  const item = memorie.get(cheie);
  if (!item) return null;
  if (Date.now() - item.cand > viata) { memorie.delete(cheie); return null; }
  return item.valoare;
}

/** Şterge tot ce începe cu prefixul dat. Se cheamă la ieşirea din cont. */
export function uita(prefix = '') {
  for (const cheie of [...memorie.keys()]) {
    if (!prefix || cheie.startsWith(prefix)) memorie.delete(cheie);
  }
}

/**
 * Aduce ceva de la server, arătând între timp ce ştim deja.
 *
 * `laDate` e chemat o dată cu valoarea din memorie (dacă există) şi încă o dată cu cea
 * proaspătă — dar a doua oară numai dacă s-a schimbat ceva. Comparaţia se face pe textul
 * JSON: e o listă de câteva zeci de rânduri, iar o comparaţie „adevărată" ar costa mai
 * mult cod decât economiseşte.
 */
export async function adu(cheie, cerere, laDate) {
  const vechi = ia(cheie);
  if (vechi !== null) laDate(vechi, true);

  const proaspat = await cerere();
  pune(cheie, proaspat);
  if (vechi === null || JSON.stringify(vechi) !== JSON.stringify(proaspat)) {
    laDate(proaspat, false);
  }
  return proaspat;
}
